import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions-page',
  templateUrl: './terms-and-conditions-page.component.html',
  styleUrls: ['./terms-and-conditions-page.component.css']
})
export class TermsAndConditionsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
